export default __webpack_public_path__ + "static/media/multiple-login.8e732dd7.png";